var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity-container"},[_c('activity-manager',{attrs:{"claimId":_vm.claim.claim_id,"perPage":10}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }